import React, {useState, useContext} from 'react';
import {useTranslation} from 'react-i18next';
import {Context} from '../../../../Helpers/Auth';
import ImageRoundedIcon from '@mui/icons-material/ImageRounded';
import imageDark from '../../../../assets/images/ImageDark.png';
import imagelight from '../../../../assets/images/ImageLight.png';
import AddShoppingCartRoundedIcon from '@mui/icons-material/AddShoppingCartRounded';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Sobre({hideTable, setHideTable, onRowClick, Item, dadosItem, codigoItem, nomeItem}) {
    //const history = useHistory();
    const {t} = useTranslation();
    const [openTab, setOpenTab] = React.useState(1);
    const idiomaAtual = localStorage.getItem('i18nextLng');

    console.log('dadosItemmm', dadosItem);
    console.log('item', Item);
    const {theme, setCarrinhoItems, carrinhoItems} = useContext(Context);
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    } else if (idiomaAtual == 'es') {
        lang = 'ES';
    }

    const unidades = [
        {value: 'kg', label: 'Quilograma (kg)'},
        {value: 'g', label: 'Grama (g)'},
        {value: 'mg', label: 'Miligrama (mg)'},
        {value: 'l', label: 'Litro (l)'},
        {value: 'ml', label: 'Mililitro (ml)'},
        {value: 'm', label: 'Metro (m)'},
        {value: 'cm', label: 'Centímetro (cm)'},
        {value: 'mm', label: 'Milímetro (mm)'},
        {value: 'un', label: 'Unidade (un)'},
    ];

    const [quantidadeTemp, setQuantidadeTemp] = useState(0);
    const [unidadeTemp, setUnidadeTemp] = useState(unidades[0].value);

    const handleAddToCart = item => {
        debugger;
        const existingItemIndex = carrinhoItems?.findIndex(e => e.id === item.id && e.unidade === unidadeTemp);
        if (existingItemIndex !== -1 && existingItemIndex != null) {
            toast.warn(t('itemExistente'), {
                position: 'top-right',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'light',
            });
        } else {
            const itemToAdd = {
                ...dadosItem,
                quantidade: quantidadeTemp,
                unidade: unidadeTemp,
            };

            setCarrinhoItems([...carrinhoItems, itemToAdd]);
            toast.success(t('addCarrinho'), {
                position: 'top-right',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'light',
            });
        }
    };

    const incrementarQuantidade = () => {
        setQuantidadeTemp(prevQuantidade => prevQuantidade + 1);
    };

    const decrementarQuantidade = () => {
        if (quantidadeTemp > 0) {
            setQuantidadeTemp(prevQuantidade => prevQuantidade - 1);
        }
    };

    const changeSelect = e => {
        setUnidadeTemp(e.target.value);
    };

    return (
        <div className="bg-gray-50 dark:bg-gray-800 py-8">
            <div className=" mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col md:flex-row -mx-4">
                    <div className="md:flex-1 px-4">
                        {/* <img className="w-full h-full object-cover" src="https://cdn.pixabay.com/photo/2020/05/22/17/53/mockup-5206355_960_720.jpg" alt="Product Image" /> */}
                        {dadosItem.foto == '' ? (
                            <div className="h-[460px] items-center justify-center flex rounded-lg bg-gray-300 dark:bg-gray-700 mb-4">
                                <img src={theme == 'dark' ? imagelight : imageDark} className="w-80 h-80" />
                            </div>
                        ) : (
                            <div className="h-[460px] rounded-lg  mb-4">
                                <img className="w-full h-full rounded-[8px]" src={'data:image/jpeg;base64,' + dadosItem.foto} />{' '}
                            </div>
                        )}
                    </div>
                    <div className="md:flex-1 px-4 ">
                        <div>
                            <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-2">
                                {dadosItem.id} - {dadosItem.nome}
                            </h2>
                            <p className="text-gray-600 dark:text-gray-300 text-sm mb-4">
                                {/* Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sed ante justo. Integer euismod libero id mauris malesuada tincidunt. */}
                            </p>
                            <div className="flex flex-row  mb-4">
                                <div className="flex flex-col mr-4">
                                    <div>
                                        <span className="font-bold text-gray-700 dark:text-gray-300 mr-2">{t('categoria')}:</span>
                                        <span className="text-gray-600 dark:text-gray-300">{dadosItem.categoria?.label ?? '-'}</span>
                                    </div>
                                    <div>
                                        <span className="font-bold text-gray-700 dark:text-gray-300 mr-2">{t('nacionalInternacional')}:</span>
                                        <span className="text-gray-600 dark:text-gray-300">{dadosItem.nacionalInternacional?.label ?? '-'}</span>
                                    </div>
                                    <div>
                                        <span className="font-bold text-gray-700 dark:text-gray-300 mr-2">{t('modelo')}:</span>
                                        <span className="text-gray-600 dark:text-gray-300">{dadosItem.modelo?.label ?? '-'}</span>
                                    </div>
                                </div>
                                <div className="flex flex-col">
                                    <div>
                                        <span className="font-bold text-gray-700 dark:text-gray-300 mr-2">{t('marca')}:</span>
                                        <span className="text-gray-600 dark:text-gray-300">{dadosItem.marca?.label ?? '-'}</span>
                                    </div>
                                    <div>
                                        <span className="font-bold text-gray-700 dark:text-gray-300 mr-2">{t('tipo')}:</span>
                                        <span className="text-gray-600 dark:text-gray-300">{dadosItem.tipo?.label ?? '-'}</span>
                                    </div>
                                    <div>
                                        <span className="font-bold text-gray-700 dark:text-gray-300 mr-2">{t('versao')}:</span>
                                        <span className="text-gray-600 dark:text-gray-300">{dadosItem.versao?.label ?? '-'}</span>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <span className="font-bold text-gray-700 dark:text-gray-300 mr-2">{t('Link')}:</span>
                                <a
                                    className="mb-5 text-base text-gray-500 sm:text-lg dark:text-gray-400 dark:hover:text-blue-500 hover:text-blue-500"
                                    href={`${dadosItem.link}`}
                                    target="_blank"
                                    rel="noopener noreferrer">
                                    {dadosItem.link || '-'}
                                </a>
                            </div>

                            {/* <div className="mb-4">
                                    <span className="font-bold text-gray-700 dark:text-gray-300">Select Color:</span>
                                    <div className="flex items-center mt-2">
                                        <button className="w-6 h-6 rounded-full bg-gray-800 dark:bg-gray-200 mr-2"></button>
                                        <button className="w-6 h-6 rounded-full bg-red-500 dark:bg-red-700 mr-2"></button>
                                        <button className="w-6 h-6 rounded-full bg-blue-500 dark:bg-blue-700 mr-2"></button>
                                        <button className="w-6 h-6 rounded-full bg-yellow-500 dark:bg-yellow-700 mr-2"></button>
                                    </div>
                                </div> */}

                            {dadosItem.comprimentoRotor != 0 && (
                                <div className="mb-4">
                                    <span className="font-bold text-gray-700 dark:text-gray-300">{t('comprimento')}:</span>
                                    <div className="flex items-center mt-2">
                                        <p className="mb-5 text-base text-gray-500 sm:text-lg dark:text-gray-400">{dadosItem.comprimentoRotor != 0 ? dadosItem.comprimentoRotor : '-'}</p>
                                    </div>
                                </div>
                            )}
                            <div className="mr-4 mb-3 ">
                                <span className="font-bold text-xl mr-2 text-gray-700 dark:text-gray-300">{t('valor')}:</span>
                                <span className="text-blue-600 text-xl font-semibold dark:text-gray-300">
                                    {Item.preco}
                                    {Item.moeda}
                                </span>
                            </div>
                            {dadosItem.observacoes != '' && (
                                <div>
                                    <span className="font-bold text-gray-700 dark:text-gray-300">{t('observacoes')}:</span>
                                    <p className="text-gray-600 dark:text-gray-300 text-sm mt-2">{dadosItem.observacoes || '-'}</p>
                                </div>
                            )}
                        </div>
                        <div className="flex flex-row items-center">
                            <div className="flex items-center mr-2 max-[500px]:justify-center h-full max-md:mt-3">
                                <div className="flex items-center h-full">
                                    <button
                                        onClick={e => {
                                            decrementarQuantidade();
                                            e.preventDefault();
                                            e.stopPropagation();
                                        }}
                                        className="group rounded-l-xl px-2 py-[8px] border border-gray-200    flex items-center justify-center shadow-sm shadow-transparent transition-all duration-500 hover:bg-gray-50 dark:bg-gray-300 dark:hover:bg-gray-200 hover:border-gray-300 hover:shadow-gray-300 focus-within:outline-gray-300">
                                        <svg
                                            className="stroke-gray-900 transition-all duration-500 group-hover:stroke-black"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="12"
                                            height="12"
                                            viewBox="0 0 22 22"
                                            fill="none">
                                            <path d="M16.5 11H5.5" stroke="" stroke-width="1.6" stroke-linecap="round" />
                                            <path d="M16.5 11H5.5" stroke="" stroke-opacity="0.2" stroke-width="1.6" stroke-linecap="round" />
                                            <path d="M16.5 11H5.5" stroke="" stroke-opacity="0.2" stroke-width="1.6" stroke-linecap="round" />
                                        </svg>
                                    </button>
                                    <input
                                        type="text"
                                        id={`quantidade_${dadosItem.id}`}
                                        className="border-y border-gray-200 dark:bg-gray-50 outline-none text-gray-900 font-semibold text-lg w-full max-w-[30px] min-w-[20px] placeholder:text-gray-900 py-[4px]  text-center bg-transparent"
                                        // placeholder="1"
                                        value={quantidadeTemp}
                                        readOnly
                                    />
                                    <button
                                        onClick={e => {
                                            incrementarQuantidade();
                                            e.preventDefault();
                                            e.stopPropagation();
                                        }}
                                        className="group rounded-r-xl px-2 py-[8px] border dark:bg-gray-300 border-gray-200 dark:hover:bg-gray-200 flex items-center justify-center shadow-sm shadow-transparent transition-all duration-500 hover:bg-gray-50 hover:border-gray-300 hover:shadow-gray-300 focus-within:outline-gray-300">
                                        <svg
                                            className="stroke-gray-900 transition-all duration-500 group-hover:stroke-black"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="12"
                                            height="12"
                                            viewBox="0 0 22 22"
                                            fill="none">
                                            <path d="M11 5.5V16.5M16.5 11H5.5" stroke="" stroke-width="1.6" stroke-linecap="round" />
                                            <path d="M11 5.5V16.5M16.5 11H5.5" stroke="" stroke-opacity="0.2" stroke-width="1.6" stroke-linecap="round" />
                                            <path d="M11 5.5V16.5M16.5 11H5.5" stroke="" stroke-opacity="0.2" stroke-width="1.6" stroke-linecap="round" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                            <div>
                                {' '}
                                <select
                                    onChange={changeSelect}
                                    value={unidadeTemp}
                                    onClick={e => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                    }}
                                    id="small"
                                    className="block w-full  p-2  text-sm text-gray-900 border border-gray-300 rounded-[8px] bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                    <option selected>{t('escolhaUnidade')}</option>
                                    {Item.unidades.map((unidade, index) => (
                                        <option key={index} value={unidade.value}>
                                            {unidade.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="flex -mx-2 mt-8 mb-4">
                            <div className="w-full px-2">
                                <button
                                    onClick={e => {
                                        handleAddToCart(dadosItem);
                                        e.preventDefault();
                                        e.stopPropagation();
                                    }}
                                    className="text-white w-full bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-[8px] text-xl px-4 py-2 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                                    <AddShoppingCartRoundedIcon /> Carrinho
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Sobre;
